export const LOAD_RATED = 'LOAD_RATED';
export const POST_RATED = 'POST_RATED';
export const DELETE_RATED = 'DELETE_RATED';
export const EDIT_RATED = 'EDIT_RATED';
